import { Link, useLocation } from "react-router-dom";
import { LayoutDashboard, HeartPulse, Folder, User, AppWindow, FileBarChart, HelpCircle } from "lucide-react";

const isActive = (p: string, t: string) => p === t || p.startsWith(t + "/");

export function PacienteMobileNav() {
  const { pathname } = useLocation();

  const navItems = [
    { to: "/paciente", icon: LayoutDashboard, label: "Inicio", exact: true },
    { to: "/paciente/minha-saude", icon: HeartPulse, label: "Saúde" },
    { to: "/paciente/aplicativos", icon: AppWindow, label: "Apps" },
    { to: "/paciente/relatorios", icon: FileBarChart, label: "Relat." },
    { to: "/paciente/categorias", icon: Folder, label: "Categ." },
    { to: "/paciente/minha-conta", icon: User, label: "Conta" },
    { to: "/paciente/suporte", icon: HelpCircle, label: "Suporte" },
  ];

  return (
    <nav
      className="
        fixed bottom-0 inset-x-0 z-40 lg:hidden
        bg-card/90 backdrop-blur border-t border-border shadow-soft
        px-1
      "
      role="navigation"
      aria-label="Menu movel"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <ul className="grid grid-cols-7 items-center h-16">
        {navItems.map((item) => (
          <li key={item.to} className="flex justify-center">
            <Link
              to={item.to}
              className={`flex flex-col items-center gap-0.5 ${
                item.exact ? pathname === item.to : isActive(pathname, item.to)
                  ? "text-primary"
                  : "text-muted-foreground"
              }`}
            >
              <item.icon className="h-4 w-4" />
              <span className="text-[10px]">{item.label}</span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
